// extracted by mini-css-extract-plugin
export var header_search = "styles-module--header_search--3biv7";
export var header_search_icon = "styles-module--header_search_icon--3tHAo";
export var header_title = "styles-module--header_title--2G5Wm";